const IberianEra = {
  id: '10',
  name: 'Iberian Era'
};

export default IberianEra;
